/* Calculador de envío – usa los endpoints AJAX de Shopify (prepare/async_shipping_rates),
   así muestra las mismas tarifas que el checkout (OCA, Rapilog, etc.). */
if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.zip = this.querySelector('[name="sc_zip"]');
      this.province = this.querySelector('[name="sc_province"]');
      this.button = this.querySelector('button[type="submit"]');
      this.results = this.querySelector('.sc__results');
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const saved = JSON.parse(localStorage.getItem('skinko_sc') || '{}');
        if (saved.zip) this.zip.value = saved.zip;
        if (saved.province) this.province.value = saved.province;
      } catch (e) {}
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.calculate(); });
    }

    params() {
      const p = new URLSearchParams();
      p.set('shipping_address[zip]', this.zip.value.trim());
      p.set('shipping_address[country]', 'Argentina');
      p.set('shipping_address[province]', this.province.value);
      return p.toString();
    }

    setLoading(on) {
      this.button.disabled = on;
      this.button.textContent = on ? 'Calculando…' : 'Calcular';
    }

    show(html) { this.results.innerHTML = html; this.results.hidden = false; }

    money(amount) {
      const n = Number(amount);
      return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(n);
    }

    fmtDate(s) {
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
      const dt = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(s);
      return dt.toLocaleDateString('es-AR', { day: 'numeric', month: 'short' });
    }

    async calculate() {
      const zip = this.zip.value.trim();
      if (!/^\d{4}$/.test(zip) && !/^[A-Za-z]\d{4}[A-Za-z]{3}$/.test(zip)) {
        this.show('<p class="sc__error">Ingresá un código postal válido (por ejemplo 1425).</p>');
        return;
      }
      if (!this.province.value) {
        this.show('<p class="sc__error">Elegí tu provincia.</p>');
        return;
      }
      try { localStorage.setItem('skinko_sc', JSON.stringify({ zip, province: this.province.value })); } catch (e) {}
      this.setLoading(true);
      this.show('<p class="sc__muted">Consultando opciones de envío…</p>');
      const q = this.params();
      try {
        const prep = await fetch(`${this.root}cart/prepare_shipping_rates.json?${q}`, { method: 'POST' });
        if (prep.status === 422) return this.renderError(await prep.json());
        let data = null;
        for (let i = 0; i < 15; i++) {
          const res = await fetch(`${this.root}cart/async_shipping_rates.json?${q}`);
          if (res.status === 422) return this.renderError(await res.json());
          if (res.status === 200) {
            const json = await res.json();
            if (json && json.shipping_rates) { data = json; break; }
          }
          await new Promise((r) => setTimeout(r, 700));
        }
        if (!data) {
          this.show('<p class="sc__error">No pudimos calcular el envío en este momento. Vas a ver las opciones en el checkout.</p>');
          return;
        }
        this.renderRates(data.shipping_rates);
      } catch (e) {
        this.show('<p class="sc__error">No pudimos calcular el envío en este momento. Vas a ver las opciones en el checkout.</p>');
      } finally {
        this.setLoading(false);
      }
    }

    renderError(json) {
      this.setLoading(false);
      const msgs = [];
      Object.values(json || {}).forEach((v) => (Array.isArray(v) ? v.forEach((m) => msgs.push(m)) : msgs.push(v)));
      this.show(`<p class="sc__error">Revisá los datos: ${msgs.join(' ') || 'dirección no válida.'}</p>`);
    }

    renderRates(rates) {
      if (!rates.length) {
        this.show('<p class="sc__error">No encontramos envíos para ese código postal. Escribinos y lo vemos.</p>');
        return;
      }
      const items = rates
        .sort((a, b) => Number(a.price) - Number(b.price))
        .map((r) => {
          const price = Number(r.price) === 0 ? '<strong>Gratis</strong>' : `<strong>${this.money(r.price)}</strong>`;
          let days = '';
          if (r.delivery_range && r.delivery_range.length === 2) {
            const a = this.fmtDate(r.delivery_range[0]);
            const b = this.fmtDate(r.delivery_range[1]);
            days = `<span class="sc__muted">${a === b ? `Llega el ${a}` : `Llega entre el ${a} y el ${b}`}</span>`;
          }
          return `<li class="sc__rate"><span class="sc__rate-name">${r.name}${days ? '<br>' + days : ''}</span>${price}</li>`;
        })
        .join('');
      this.show(`<ul class="sc__list">${items}</ul><p class="sc__muted">El costo final se confirma en el checkout.</p>`);
    }
  }
  customElements.define('shipping-calculator', ShippingCalculator);
}
